import { useContext, useEffect, useState } from 'react';
import { AppContext } from '@utils/browser/app-context';
import getChangeAccount from '@model/change-account';
import logout from '@model/logout';
import { UserData } from '@hooks/useLogin';
import { message } from '@tencent/tea-component';
import { addURLSearch } from '@tencent/web-base';

export const useAccountInfo = () => {
  const { userData, statusInfo } = useContext(AppContext);
  const [canChangeAccount, updateCanStatus] = useState<boolean | undefined>(undefined);
  const [info, setInfo] = useState<
    Partial<{
      canChangeAccount: boolean;
      name: string;
      avatar: string;
      enterSpace: boolean;
      app_id: string;
      userid: string;
      isHost: boolean;
    }>
  >({});
  useEffect(() => {
    let newInfo = { ...info };
    if (userData?.userid) {
      newInfo = {
        ...newInfo,
        name: userData?.nick_name,
        avatar: userData?.avatar,
        app_id: userData.app_id,
        userid: userData?.userid,
      };
    }
    if ((statusInfo?.is_host || statusInfo?.is_host_org_member) && !info?.isHost) {
      newInfo = { ...newInfo, isHost: true };
    }
    if (statusInfo?.is_show_activity_room && !newInfo.enterSpace) {
      newInfo = { ...newInfo, enterSpace: statusInfo.is_show_activity_room };
    }
    if (canChangeAccount !== undefined) {
      newInfo = { ...newInfo, canChangeAccount };
    }
    setInfo(newInfo);
  }, [userData, canChangeAccount, statusInfo]);

  useEffect(() => {
    if (userData?.userid && canChangeAccount === undefined) {
      // 当前账户是否可以切换账号类型
      getChangeAccount().then((res) => {
        updateCanStatus(!!res?.data?.is_can_change_account);
      });
    }
  }, [userData, canChangeAccount]);

  return info;
};

export type Action = 'meeting' | 'pay' | 'change-account' | 'logout';
export const accountAction =
  (userData: Partial<UserData>, pathname?: string) => (action: Action) => {
    switch (action) {
      case 'meeting':
        {
          const meetingUrl = `${window.location.origin}/user-center/webinar`;
          const w = window.open('about:blank');
          if (w) {
            w.location.href = meetingUrl;
          } else {
            window.location.href = meetingUrl;
          }
        }
        break;
      case 'pay':
        {
          const payUrl = `${window.location.origin}/user-center/order-management`;
          const w = window.open('about:blank');
          if (w) {
            w.location.href = payUrl;
          } else {
            window.location.href = payUrl;
          }
        }
        break;
      case 'change-account':
        {
          window.location.href = `${
            window.location.origin
          }/select-account-type.html?change-account=1&appid=${userData?.app_id}&redirect_link=${encodeURIComponent(
            addURLSearch(location.href, {
              'change-account': 1,
            }),
          )}`;
        }
        break;
      case 'logout':
        {
          logout()
            .then((res) => {
              if (res.code === 0 && res.data) {
                sessionStorage.clear();
                if (pathname === '/event/[eventid]/registration') {
                  window.location.reload();
                  return;
                }
                window.location.href = `${window.location.origin}/index.html`;
              } else {
                message.warning({
                  content: '后台服务出错，请重试退出',
                });
              }
              return res;
            })
            .catch((e) => {
              window.nextAegis.infoAll(e);
            });
        }
        break;
      default:
        break;
    }
  };
